export const MANUAL = 'manual';
export const MAX_WEIGHT = 'max-weight';
export const QUANTITY = 'quantity';

export default [MANUAL, MAX_WEIGHT, QUANTITY];
